import { Controller } from '@hotwired/stimulus'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
export default class extends Controller {

    connect () {
        gsap.set(this.element, {
            opacity: 0,
            y:       150,
        })

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.element, // The footer is the trigger
                start:   'top 30%', // Animation starts when the footer's top is 40% from the top of the viewport
                end:     'top 0%', // Animation ends when the footer's top is 20% from the top of the viewport
                scrub:   true, // Links the animation progress to the scrollbar
            }
        })

        // Add the animation to the timeline
        timeline.to(this.element, {
            opacity: 1,
            y:       0,
            ease:    'none',
        })
    }
}
